export const ANALYTICS_EVENTS = {
  CHECKOUT_LOADED: 'checkout_loaded',
  CHECKOUT_STEP_CHANGE: 'checkout_step_change',
  CHECKOUT_PAYMENT_METHOD_SELECTED: 'checkout_payment_method_selected',
  CHECKOUT_VALIDATION_ERROR: 'checkout_validation_error',
  CHECKOUT_COMPLETED: 'checkout_completed',
} as const;

export const ANALYTICS_PROPERTIES = {
  MERCHANT: 'merchant',
  PRODUCT: 'product',
  CHECKOUT: 'checkout',
  TEMPLATE: 'template',
  COUNTRY: 'country',
  LANGUAGE: 'language',
  AFFILIATE: 'affiliate',
} as const;

export type CheckoutStep = 'personal_data' | 'address' | 'payment';

export type PaymentMethod =
  | 'pix'
  | 'card'
  | 'boleto'
  | 'paypal'
  | 'applepay'
  | 'googlepay'
  | 'amazonpay'
  | string;

export type ValidationField =
  | 'email'
  | 'cpf'
  | 'zipCode'
  | 'fullName'
  | 'phoneNumber'
  | 'postalCode'
  | 'state'
  | 'city'
  | 'neighborhood'
  | 'address'
  | 'number'
  | 'cardNumber'
  | 'cardName'
  | 'cardExpiry'
  | 'cardCvv'
  | string;

export type PaymentStatus = 'success' | 'pending' | 'failed';
